// @ts-strict-ignore
import * as React from 'react';

import OverflowContainer from 'components/overflow-container';
import { DismissibleTag } from 'components/tag';
import { Label, Text } from 'components/typography';

import { CuratorOptions } from 'api';
import { FormattedMessage, useIntl } from 'react-intl';

import { CURATOR_OPTIONS } from '../search-filters';

type PlaylistsSearchTagsProps = {
  removeTopic: (topic: string) => void;
  clearAll: () => void;
  topics: Array<string>;
  curator: CuratorOptions;
  setCurator: (curator: string | null) => void;
};

function PlaylistsSearchTags({
  removeTopic,
  clearAll,
  topics,
  curator,
  setCurator
}: PlaylistsSearchTagsProps): React.ReactNode {
  const intl = useIntl();
  const clearButtonAria = intl.formatMessage({
    defaultMessage: 'Clear all filters'
  });
  const clearButtonText = intl.formatMessage({
    defaultMessage: 'Clear'
  });
  return (
    <OverflowContainer>
      <div className="row flex flex-nowrap items-center md:flex-wrap">
        <Label className="mr-3 hidden md:mb-3 md:inline-block lg:mr-4">
          <FormattedMessage defaultMessage="Active filters:" />
        </Label>

        {topics?.map(topic => {
          return (
            <DismissibleTag
              key={topic}
              text={topic}
              onClick={() => removeTopic(topic)}
              className="mr-2 capitalize md:mb-3 md:mr-3"
            />
          );
        })}

        {curator && (
          <DismissibleTag
            text={
              CURATOR_OPTIONS.filter(item => item.value === curator)[0]?.label
            }
            onClick={() => setCurator(null)}
            className="mr-2 capitalize md:mb-3 md:mr-3"
          />
        )}

        <button
          type="button"
          onClick={clearAll}
          className="ml-2 font-bold underline hover:text-gray-700 md:mb-3 lg:ml-3"
          aria-label={clearButtonAria}
        >
          <Text size="m" className="whitespace-nowrap" aria-hidden>
            {clearButtonText}
          </Text>
        </button>
      </div>
    </OverflowContainer>
  );
}

export default PlaylistsSearchTags;
